<template>
    <div class="page-footer">
        <div class="footer-nav">
            <div class="container">
                <div class="">
                    <span></span>
                    <ul>
                        © Администрация города Перми.
                        Разработка и поддержка сайта: ООО "ИТИС"
                        2016 - 2020 гг.
                    </ul>

                    <ul>
                        Адрес: 614000 г. Пермь, ул. Ленина, 23
                    </ul>

                    <ul>
                        Контактная информация по обращениям граждан:
                        Тел.: (342) 217 33 17
                    </ul>

                    <ul>
                        Контактная информация для юридических лиц:
                        Тел.: (342) 217 33 46
                        Email: agp@perm.permkrai.ru
                    </ul>

                    <ul>
                        <li class="special visible-lg">
                            <a class="icon-special" id="eyedisTriggerButtonOn"
                                @click.prevent="() => setEyedis('print', true)">
                                Версия для слабовидящих
                            </a>
                        </li>
                    </ul>
                    <ul v-if="eyedis.print">
                        <li class="visible-lg">
                            <a class="" id="eyedisTriggerButtonOff" @click.prevent="() => setEyedis('print', false)">
                                Вернуться на обычную версию сайта
                            </a>
                        </li>
                    </ul>

                    <ul>
                        Для решения технических вопросов работы Интернет-приемной администрации города Перми
                        вы можете обращаться по электронной почте:
                        <a href="mailto:tp_ip_agp@gorodperm.ru">tp_ip_agp@gorodperm.ru</a>
                    </ul>
                    <!--span>Пермский край</span>

                    <ul>
                        <li><a href="http://invest.gorodperm.ru/" target="_blank" class="">Инвестиционный портал </a></li>

                        <li><a href="http://pravo.gov.ru/" target="_blank" class="">Официальный интернет-портал правовой информации </a></li>

                        <li><a href="http://www.zakupki.gov.ru/epz/main/public/home.html" target="_blank" class="">Портал закупок </a></li>

                        <li><a href="https://budget.permkrai.ru/" target="_blank" class="">Понятный бюджет </a></li>

                        <li><a href="http://www.visitperm.ru/" target="_blank" class="">Официальный туристический сайт Пермского края </a></li>

                        <li><a href="http://permarea.ru/" target="_blank" class="">Портал муниципальных образований Пермского края </a></li>

                        <li class="special visible-lg"><a class="icon-special" id="eyedisTriggerButtonOn" href="#!">Версия для слабовидящих</a></li>
                    </ul-->
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-12">
                        <!--span>Разделы сайта</span>

                    <ul>
                        <li><a href="//gubernator.permkrai.ru/main/" class="">Губернатор</a></li>

                        <li><a href="//permkrai.ru/news/" class="">Новости региона </a></li>

                        <li><a href="//permkrai.ru/government/" class="">Правительство </a></li>

                        <li><a href="https://www.gosuslugi.ru/" target="_blank" class="">Услуги и сервисы </a></li>

                        <li><a href="http://permkrai.ru/documents/" target="_blank" class="">Документы </a></li>

                        <li><a href="http://permkrai.ru/information-income/normative-acts-of-anti-corruption/" target="_blank" class="">Противодействие коррупции </a></li>
                    </ul-->
                    </div>

                    <div class="col-lg-3 col-md-12">
                        <!--span>Органы власти</span>

                    <ul>
                        <li><a href="http://permkrai.ru/government/authority/#ministry" class="authority-link">Министерства </a></li>

                        <li><a href="http://permkrai.ru/government/authority/#agency" class="authority-link">Агентства </a></li>

                        <li><a href="http://permkrai.ru/government/authority/#inspection" class="authority-link">Инспекции </a></li>

                        <li><a href="http://permkrai.ru/government/authority/#committee" class="authority-link">Службы и комитеты </a></li>
                    </ul-->
                    </div>
                </div>
            </div>
        </div>
        <!--
        <div class="footer">
            <div class="container">
                <a href="/" class="logo-title">Сайт губернатора<br>и Правительства Пермского края</a>

            <div class="pull-right">
                <span class="address">614006, г. Пермь, ул. Куйбышева, д.14</span>

                <div class="icon-social">
                    <a href="https://vk.com/public143106820" class="outline vk" target="_blank"><span class="icon"></span></a>
                    <a href="https://www.facebook.com/%D0%9F%D1%80%D0%B5%D1%81%D1%81-%D1%81%D0%BB%D1%83%D0%B6%D0%B1%D0%B0-%D0%B3%D1%83%D0%B1%D0%B5%D1%80%D0%BD%D0%B0%D1%82%D0%BE%D1%80%D0%B0-%D0%9F%D0%B5%D1%80%D0%BC%D1%81%D0%BA%D0%BE%D0%B3%D0%BE-%D0%BA%D1%80%D0%B0%D1%8F-1331792363580644/"
                    target="_blank" class="outline fb">
                        <span class="icon"></span>
                    </a>
                    <a href="https://www.youtube.com/channel/UCK2-hVXf_A0Hb4AGe2n7WCQ/videos" class="outline youtube" target="_blank"><span class="icon"></span></a>
                </div>
            </div
            </div>
        </div>-->
    </div>
</template>

<script>

export default {
    props: ['eyedis', 'setEyedis'],
};
</script>